import CustomElement from "./CustomElement";
import Swiper from "swiper/bundle";
import "swiper/css";

/**
 * A slot element for Swiper carousels
 * @typedef {Object} CustomElement~Carousel
 */
export default class CarouselWrapper extends CustomElement {

	constructor() {
		super();
		this.carouselEl = this.querySelector(".slider");
		this.carouselWrapper = this.querySelector('.slider-slides');
		if (this.carouselEl.dataset.asAnchors != undefined) {
			this.anchors = Array.from(document.querySelectorAll('.anchor'))
			this.anchorTargets = this.anchors.map(a => ({
				id: a.getAttribute('id'),
				title: a.querySelector('h3').innerText
			}));
			this.buttons = this.anchorTargets.map(anchor => `<a href="#${anchor.id}" class="slider-slide pill faq-nav-pill">${anchor.title}</a>`);
			this.buttons.forEach((btn) => {
				this.carouselWrapper.insertAdjacentHTML('beforeend', btn)
			})
		}
		this.slides = this.carouselEl.querySelectorAll(".slider-slide");
		this.pagination = this.querySelector(".slider-pagination");
		this.navigation = this.querySelector(".slider-navigation");
		/**
		 * All the dataset attributes
		 * @param	{Object}	this.data
		 * @param	{string}	this.data
		 */
		this.data = this.carouselEl.dataset;
		this.anim = (this.data.animation) ? this.data.animation.toLowerCase() : "slide";
		this.modules = [];



		if (this.data.thumbsSelector !== undefined) {

			this.thumbnailsElSelector = this.data.thumbsSelector;
			this.thumbs = this.querySelector(this.thumbnailsElSelector) ?? this.parentElement?.querySelector(this.thumbnailsElSelector);

			if (this.thumbs) {

				this.thumbsType = this.thumbs.tagName;

				/** Non-swiper case for thumbs */
				if (this.thumbsType.toLowerCase() != "carousel") {

					if (this.pagination) {
						this.pagination = {
							el: this.thumbs,
							type: "bullets"
						}
					}

					this.thumbs = false;
				}

			} else {
				this.pagination = undefined;
			}
		}
		// this.slideIndex = this.carouselEl.querySelector(".slide-index")

		this.init();
	}


	init() {

		let desktopGutter = (this.data.gutter) ? parseInt(this.data.gutter) : 60;
		let mobileGutter = (this.data.gutter) ? parseInt(this.data.gutter) : 30;

		this.options = {
			autoplay: (this.data.autoplay != undefined) ? {
				delay: parseFloat(this.data.timing),
				disableOnInteraction: false,
				waitForTransition: false
			} : false,
			breakpoints: {
				768: {
					spaceBetween: (this.data.mobileOnly != undefined) ? 1000 : desktopGutter // we set an arbitrary value here to check against
				}
			},
			// centerInsufficientSlides: true,
			// centeredSlidesBounds: true,
			containerModifierClass: "slider-",
			slideActiveClass: "slide-active",
			slideClass: "slider-slide",
			wrapperClass: "slider-slides",
			slideDuplicateActiveClass: "slide-active-duplicate",
			slideDuplicateClass: "slide-duplicate",
			slideDuplicateNextClass: "slide-next-duplicate",
			slideDuplicatePrevClass: "slide-prev-duplicate",
			slidePrevClass: "slide-prev",
			slideNextClass: "slide-next",
			slideVisibleClass: "slide-visible",
			centeredSlides: this.data.centered != undefined ? true : false,
			effect: this.anim,
			height: (this.data.height) ? parseInt(this.data.height) : null,
			loop: this.data.loops !== undefined,
			// loopedSlides: this.data.loops !== undefined ? this.slides.length : null,
			// allowSlideNext: true,
			// allowSlidePrev: true,
			pagination: (this.pagination != undefined) ? {
				bulletActiveClass: "active",
				bulletClass: "slider-pagination-bullet",
				clickable: true,
				clickableClass: "slider-pagination-clickable",
				currentClass: "slider-pagination-current",
				el: (this.pagination.el) ? this.pagination.el : ".slider-pagination",
				type: (this.pagination.type) ? this.pagination.type : "bullets"
			} : false,
			navigation: {
				disabledClass: "slider-button-disabled",
				enabled: true,
				hiddenClass: "slider-button-hidden",
				hideOnClick: false,
				lockClass: "slider-button-lock",
				navigationDisabledClass: "slider-navigation-disabled",
				nextEl: this.querySelector(".slider-button-next"),
				prevEl: this.querySelector(".slider-button-prev")
			},
			slidesPerView: this.data.slidesperview || "auto",
			spaceBetween: mobileGutter,
			speed: parseInt(this.data.speed),
			thumbs: this.thumbs,
			on: {
				// !FIXME: WHy does this break resize
				// breakpoint: (swiper, breakpointParams) => {

				// 	if (breakpointParams.spaceBetween >= 1000) {
				// 		swiper.destroy();
				// 	}
				// },
				click: (swiper) => {


				},
				paginationRender: (swiper, paginationEl) => {

				},
				init: (swiper) => {

					const colorAttr = false;
					// swiper.slides[swiper.activeIndex].dataset.color;
					// if (this.slideIndex) this.slideIndex.innerText = `1 of ${swiper.slides.length}`

					if (colorAttr) swiper.$el[0].style.backgroundColor = colorAttr;

					window.Zero.lazyLoad.update();
				},
				slideChange: (swiper) => {
					const colorAttr = swiper.slides[swiper.activeIndex] && swiper.slides[swiper.activeIndex].dataset.color;
					if (colorAttr) swiper.el.style.backgroundColor = colorAttr
					if (this.slideIndex) this.slideIndex.innerText = `${swiper.activeIndex} of ${swiper.slides.length}`
				}
			}
		};

		console.log(this.data, this.dataset, this.options);



		/** Effects */
		switch (this.anim) {

			case "crossfade":

				this.options.fadeEffect = {
					crossFade: true
				};

				break;

			default:

				break;
		}

		/** Set up our carousel */
		if (this.data.mobileOnly === undefined || window.Zero.windowWidth <= 768) {
			this.carousel = new Swiper(this.carouselEl, this.options);
		}
	}

	onResized(event) {

		if (this.data.mobileOnly === undefined) return;

		if (window.Zero.windowWidth <= 768) {

			if (!this.carousel || this.carousel.destroyed === true) {

				this.carousel = new Swiper(this.carouselEl, this.options);
			}

		} else if (this.carousel && !this.carousel.destroyed) {

			this.carousel.destroy(true, true);
		}
	}
	connectedCallback() {
		if (this.carouselEl.dataset.asAnchors != undefined) {
			document.documentElement.style.setProperty("scroll-behavior", "smooth")
		}
	}
	disconnectedCallback() {
		if (this.carouselEl.dataset.asAnchors != undefined) {
			document.documentElement.style.removeProperty('scroll-behavior')
		}
	}
}
